import React from 'react';

interface DatabasesIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export const DatabasesIcon: React.FC<DatabasesIconProps> = ({ size = 20, ...props }) => {
  return (
    <svg
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      height={size}
      width={size}
    >
      <path
        clipRule="evenodd"
        d="M10 3.143c-1.73 0-3.354.26-4.515.695-.582.218-.984.457-1.227.677-.244.22-.271.366-.271.422 0 .055.027.2.27.421.244.22.646.46 1.228.677 1.16.436 2.785.695 4.514.695 1.73 0 3.354-.26 4.515-.695.581-.218.983-.456 1.227-.677.244-.22.27-.366.27-.421 0-.056-.026-.201-.27-.422-.244-.22-.646-.459-1.227-.677m1.498 3.128c-.295.168-.624.319-.98.452-1.37.514-3.18.789-5.033.789-1.852 0-3.662-.275-5.033-.789a6.752 6.752 0 0 1-.98-.452V10c0 .056.028.2.272.421.243.22.645.46 1.227.678 1.16.435 2.785.694 4.514.694 1.73 0 3.354-.259 4.515-.694.581-.218.983-.457 1.227-.678.244-.22.27-.365.27-.421V6.966Zm0 5.063c-.295.168-.624.32-.98.453-1.37.514-3.18.788-5.033.788-1.852 0-3.662-.274-5.033-.788a6.75 6.75 0 0 1-.98-.453v3.034c0 .056.028.201.272.422.243.22.645.459 1.227.677 1.16.435 2.785.695 4.514.695 1.73 0 3.354-.26 4.515-.695.581-.218.983-.457 1.227-.677.244-.221.27-.366.27-.422V12.03ZM2.51 4.937c0-.616.328-1.129.756-1.517.43-.388 1.016-.708 1.7-.965 1.371-.514 3.181-.788 5.033-.788 1.852 0 3.662.274 5.033.788.685.257 1.271.577 1.7.965.428.388.757.901.757 1.517v10.126c0 .616-.329 1.129-.757 1.516-.429.389-1.015.71-1.7.966-1.37.514-3.18.788-5.033.788-1.852 0-3.662-.274-5.033-.788-.684-.257-1.27-.578-1.7-.966-.428-.387-.756-.9-.756-1.516V4.937ZM10 3.143c1.728 0 3.353.26 4.514.695l-4.515-.695Z"
        fill="#B5BCC4"
        fillRule="evenodd"
      />
    </svg>
  );
};
